import { AdminCrudPage, AdminCrudPageConfig } from '@/components/admin';

const config: AdminCrudPageConfig<{ id: string; [key: string]: unknown }> = {
  title: 'API Configurations',
  apiEndpoint: '/insurers/api-configs/',
  queryKey: 'apiConfigs',
  columns: [
    { key: 'insurer_name', label: 'Insurer' },
    { key: 'environment_display', label: 'Environment' },
    { key: 'endpoint_name', label: 'Endpoint' },
    { key: 'endpoint_url', label: 'URL' },
    { key: 'http_method', label: 'Method' },
    { key: 'auth_type_display', label: 'Auth Type' },
    { key: 'is_active', label: 'Status', render: (v: unknown) => (v ? 'Active' : 'Inactive') },
  ],
  formFields: [
    { name: 'insurer', label: 'Insurer', type: 'select', apiEndpoint: '/insurers/insurers/', required: true, searchable: true },
    { name: 'environment', label: 'Environment', type: 'select', options: [
      { value: 'sandbox', label: 'Sandbox' },
      { value: 'production', label: 'Production' },
    ], required: true },
    { name: 'endpoint_name', label: 'Endpoint Name', type: 'text', required: true },
    { name: 'endpoint_url', label: 'Endpoint URL', type: 'text', required: true },
    { name: 'http_method', label: 'HTTP Method', type: 'select', options: [
      { value: 'GET', label: 'GET' },
      { value: 'POST', label: 'POST' },
      { value: 'PUT', label: 'PUT' },
      { value: 'PATCH', label: 'PATCH' },
    ], required: true },
    { name: 'auth_type', label: 'Auth Type', type: 'select', options: [
      { value: 'none', label: 'None' },
      { value: 'api_key', label: 'API Key' },
      { value: 'basic', label: 'Basic Auth' },
      { value: 'oauth2', label: 'OAuth 2.0' },
      { value: 'certificate', label: 'Client Certificate' },
    ], required: true },
    { name: 'auth_credentials_ref', label: 'Credentials Reference', type: 'text' },
    { name: 'timeout_seconds', label: 'Timeout (seconds)', type: 'number' },
    { name: 'retry_count', label: 'Retry Count', type: 'number' },
    { name: 'is_active', label: 'Active', type: 'boolean' },
  ],
  searchPlaceholder: 'Search API configs...',
  hasActivate: true,
};

export function ApiConfigsPage() {
  return <AdminCrudPage config={config} />;
}
